module.exports = __webpack_public_path__ + "img/babybook-history.c5495c93.svg";